import { useEffect, useState } from "react";
import { fetchCurriculum } from "@/lib/api";
import WeekCard from "@/components/WeekCard";
import { useLang } from "@/contexts/LangContext";

export default function CurriculumList() {
    const { lang, t } = useLang();
    const [weeks, setWeeks] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        fetchCurriculum(lang)
            .then(setWeeks)
            .finally(() => setLoading(false));
    }, [lang]);

    return (
        <main
            className="max-w-7xl mx-auto px-5 md:px-8 pt-12 md:pt-20 pb-20 relative"
            data-testid="curriculum-page"
        >
            <div className="glow glow-lime -top-20 -left-20" />
            <div className="relative z-10">
                <span className="tag">{t.curriculum.tag}</span>
                <h1 className="font-display font-black text-white text-5xl md:text-7xl mt-4 uppercase leading-[0.92]">
                    {t.curriculum.head_a}{" "}
                    <span className="font-brush text-[var(--lime)] inline-block -rotate-3">
                        {t.curriculum.head_b}
                    </span>
                </h1>
                <p className="font-mono text-[var(--muted)] mt-5 max-w-2xl">
                    {t.curriculum.blurb}
                </p>
            </div>
            {loading ? (
                <p className="font-mono text-[var(--muted)] mt-16">
                    {t.curriculum.loading}
                </p>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mt-14 relative z-10">
                    {weeks.map((w, i) => (
                        <WeekCard key={w.id} week={w} index={i} />
                    ))}
                </div>
            )}
        </main>
    );
}
